import { Resource } from "../resource/resource.model";

/**
 * User Favorite - represents a menu item marked as favorite by the user
 */
export class UserFavorite extends Resource {
  userId: string;
  displayName: string;
  iconClass: string;
  route: string;
  order: number;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(
    userId: string,
    displayName: string,
    iconClass: string,
    route: string,
    order: number = 0
  ) {
    super();
    this.userId = userId;
    this.displayName = displayName;
    this.iconClass = iconClass;
    this.route = route;
    this.order = order;
  }
}
